class SupplementFinderRecommendations extends HTMLElement {
  constructor() {
    super();
    this.loader = this.querySelector("#loader");
  }

  connectedCallback() {
    // If localStorage has a key "supplement_finder_1" this key will be an object with "recommendations" property which is an object with the product handles as keys.
    // Get these keys and add a URL parameter "recommendations" with the keys to the current URL.
    let recommendations = null;
    let recommendationIds = null
    const url = new URL(window.location.href);
    
    if ( url.searchParams.get("recommendations") ) {
      recommendations = url.searchParams.get("recommendations");
      recommendationIds = recommendations.split("+");
      console.log('LOADING FROM URL')
      
    } else if ( this.dataset.recommendations ) {
      recommendations = this.dataset.recommendations
      recommendationIds = recommendations.split("+");
      console.log('LOADING FROM METAFIELD')
      
    } else if ( localStorage.getItem("supplement_finder_1") != null ) {
      recommendations = localStorage.getItem("supplement_finder_1");
      const productHandles = recommendations ? JSON.parse(recommendations).recommendations : {};
      recommendationIds = Object.keys(productHandles);
      console.log('LOADING FROM LOCAL STORAGE')
    }
    
    if ( recommendations && recommendationIds != null && recommendationIds.length ) {
      const url = new URL(window.location.href);
      url.searchParams.set("recommendations", recommendationIds.join("+"));
      window.history.replaceState({}, "", url);
      this.fetchData();
      
    } else {
      // Create a div element with a message that there are no recommendations and hide the loader after 1 second
      const noRecommendations = document.createElement("div");
      noRecommendations.classList.add("p-4", "text-center", "col-span-full");
      noRecommendations.innerHTML = `
          <p class="text-lg">No recommendations found</p>
          <p>Click on the Supplement Finder popout to the right and fill in our quiz.</p>
        `;
      setTimeout(() => {
        this.hideLoader();
        this.appendChild(noRecommendations);
      }, 1000);
    }
  }

  // Read from the page URL parameter "recommendations" to fetch the recommendations
  async fetchData() {
    const url = new URL(window.location.href);
    let recommendations = url.searchParams.get("recommendations") ? url.searchParams.get("recommendations") : this.dataset.recommendations;
    if ( !recommendations ) {
      this.hideLoader();
      return;
    }
    console.log('🚀 recommendations: ', recommendations);
    // For each recommendation, fetch the product data and render it
    const recommendationIds = recommendations.split("+");

    const fetchPromises = recommendationIds.map((id) => this.fetchProduct(id));
    const results = await Promise.allSettled(fetchPromises);

    results.forEach((result) => {
      if (result.status === "fulfilled" && result.value) {
        this.renderProduct(result.value);
      } else {
        console.error(result.reason);
      }
    });

    this.hideLoader();
  }

  async fetchProduct(id) {
    try {
      const response = await fetch(
        `${window.location.origin}/products/${id}?sections=product-card`,
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch product with id ${id}`);
      }
      const product = await response.json();
      return product["product-card"];
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  renderProduct(product) {
    const productCard = document.createElement("div");
    productCard.innerHTML = product;
    // On the same page there's a const productsOrder which is an object of keys (the product handles) and values (integers) which represent the order of the products. For each product card, get the product handle and set the order of the product card to the value of the product handle in the productsOrder object.
    const productHandle = productCard.querySelector(".product-card").dataset.product;
    const order = productsOrder[productHandle];
    productCard.style.order = order;

    console.log('productCardHandle: ', productCard.querySelector('.product-card').dataset.product );
    
    if ( productHandle != '' && productHandle != null ) {
      this.appendChild(productCard);
    }
    
  }

  hideLoader() {
    if (this.loader) {
      this.loader.style.display = "none";
    }
  }
}

customElements.define("sf-recommendations", SupplementFinderRecommendations);
